(ns minorodata.components.not-found.core
  (:require
   [minorodata.app.handlers :refer [dispatch]]
   [ui.button :as button]
   [ui.page :as page]
   [ui.typography :as typography]))

(defn not-found-page []
  [page/page-root
   [page/page-content
    [:div {:class "h-full w-full flex items-center justify-center flex-col"}
     [typography/h1 {:class "text-8xl font-black text-kleene-text-secondary mb-1"} "404"]
     [typography/h2 {:class "mb-4"} "Page Not Found"]
     [typography/p {:class "mb-8"} "The page you're looking for does not exist."]
     [button/button {:variant :secondary
                     :on-click #(dispatch [:app.events/navigate :overview])}
      "Return to home screen"]]]])
